@if (alertDetalhesBeneficio) {
  <div class="body-alert">
    <div class="div-detalhes-operadora text-center">
      <div class="div-titulo-detalhes">
        <p class="titulo-detalhes">Detalhes</p>
        <div class="div-botao-fechar">
          <button
            class="btn-icon"
            aria-label="Fechar detalhes"
            (click)="cancelarDetalhesBeneficio()"
            >
            <i class="fa fa-times ci-gray fa-2x" aria-hidden="true"></i>
          </button>
        </div>
      </div>
      <div class="coluna-detalhes">
        <div class="codigo-detalhes">
          <p class="texto-titulo text-start mt-3">Código</p>
          <p class="subtitulo-alert text-start text-nowrap">{{ beneficioResponse?.codigo }}</p>
        </div>
        <div class="descricao-detalhes">
          <p class="texto-titulo text-start mt-3">Descrição</p>
          <p class="subtitulo-alert text-start" >{{ $safeNavigationMigration(beneficioResponse?.descricao) | titlecase}}</p>
        </div>
        <div class="grupo-detalhes">
          <p class="texto-titulo text-start mt-3">Grupo</p>
          <p class="subtitulo-alert text-start text-nowrap">{{ $safeNavigationMigration(beneficioResponse?.grupo)  | titlecase}}</p>
        </div>
        <div class="subitem-detalhes">
          <p class="texto-titulo text-start mt-3">Sub-item</p>
          <p class="subtitulo-alert text-start text-nowrap">{{ $safeNavigationMigration(beneficioResponse?.subItem) | titlecase }}</p>
        </div>
      </div>
      <div class="coluna-detalhes">
        <div class="detalhes-beneficio-second-row">
          <p class="texto-titulo text-start mt-3">Facial</p>
          <p class="subtitulo-alert text-start">{{ $safeNavigationMigration(beneficioResponse?.flagFacial) | titlecase}}</p>
        </div>
        <div class="detalhes-beneficio-second-row">
          <p class="texto-titulo text-start mt-3">Blocado</p>
          <p class="subtitulo-alert text-start">{{ $safeNavigationMigration(beneficioResponse?.flagBlocado) | titlecase}}</p>
        </div>
        <div class="detalhes-beneficio-second-row">
          <p class="texto-titulo text-start mt-3">Unitário</p>
          <p class="subtitulo-alert text-start">{{ $safeNavigationMigration(beneficioResponse?.flagUnitario) | titlecase}}</p>
        </div>
        <div class="detalhes-beneficio-second-row">
          <p class="texto-titulo text-start mt-3">Período</p>
          <p class="subtitulo-alert text-start">{{ $safeNavigationMigration(beneficioResponse?.flagPeriodo) | titlecase}}</p>
        </div>
        <div class="col-lg-6">
          <p class="texto-titulo text-start mt-3">Dados Obrigatórios</p>
          <p class="subtitulo-alert text-start">{{ $safeNavigationMigration(beneficioResponse?.dadosObrigatorios) | titlecase}} </p>
        </div>
      </div>
      <div class="coluna-detalhes">
        <div class="custo-via-um">
          <p class="texto-titulo text-start mt-3">Custo 1ª via</p>
          <p class="subtitulo-alert text-start text-nowrap">{{ beneficioResponse?.custo1Via}}</p>
        </div>
        <div class="custo-via-dois">
          <p class="texto-titulo text-start mt-3">Custo 2ª via</p>
          <p class="subtitulo-alert text-start text-nowrap">{{ beneficioResponse?.custo2Via}}</p>
        </div>
        <div class="custo-credito">
          <p class="texto-titulo text-start mt-3">Custo por crédito </p>
          <p class="subtitulo-alert text-start">{{ beneficioResponse?.custoCredito}}</p>
        </div>
      </div>
      <div class="coluna-detalhes">
        <div class="minimo-primeiro-credito">
          <p class="texto-titulo text-start mt-3">Valor mínimo 1ª crédito </p>
          <p class="subtitulo-alert text-start text-nowrap">{{ beneficioResponse?.valorMin1Credito}}</p>
        </div>
        <div class="minimo-demais-credito">
          <p class="texto-titulo text-start mt-3 text-nowrap">Valor mínimo demais créditos</p>
          <p class="subtitulo-alert text-start text-nowrap">{{ beneficioResponse?.valorMinDemaisCreditos}}</p>
        </div>
        <div class="maximo-credito">
          <p class="texto-titulo text-start mt-3">Valor máximo demais créditos</p>
          <p class="subtitulo-alert text-start">{{ beneficioResponse?.valorMaxDemaisCreditos }}</p>
        </div>
      </div>
      <div class="descricao-operadora">
        <p class="texto-titulo text-start mt-3">Descrição</p>
        <p class="subtitulo-descricao-operadora text-start">{{ beneficioResponse?.descritivo}}</p>
      </div>
      <button type="button" class="botao-fechar-detalhes" (click)="cancelarDetalhesBeneficio()">FECHAR</button>
    </div>
  </div>
}
